<template>
  <section class="result">
    <div class="result__icon">
      <van-image width="100" height="100" :src="wait_img" />
    </div>
    <div class="result__title">开票中</div>
    <div class="result__remark">
      请稍后前往缴费记录查看。
    </div>
    <!-- <div class="result__countdown">
      自动退出本页面:
      <van-count-down @finish="handleRefresh" :time="Countdown" style="color:#FF3366;" ref="countDown" />
    </div> -->
  </section>
</template>

<script>
import wait_img from '@/assets/payment-related/img_pay_wait.png'
import { Image, CountDown, Button } from 'vant'
export default {
  name: 'InvoiceWait',
  computed: {
  },
  components: {
    [Image.name]: Image,
    [CountDown.name]: CountDown,
    [Button.name]: Button,
  },
  data () {
    return {
      wait_img,
      Countdown: 15 * 1000,
    }
  },
  methods: {
    // handleRefresh () {
    //   this.$router.push({ name: 'Personal-Center' })
    // }
  }
}
</script>

<style lang="scss" scoped>
.result {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  text-align: center;
  color: #444444;
  padding-top: 10vh;
  &__title {
    font-size: 22px;
    line-height: 48px;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    letter-spacing: 1.75px;
  }
  &__remark {
    font-size: 14px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  &__tips {
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
  &__countdown {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
    text-align: center;
  }
  &__orderInfo {
    font-size: 14px;
    line-height: 24px;
    font-family: PingFang-SC-Medium;
    letter-spacing: 1.25px;
    font-weight: bold;
  }
}
</style>